
import Vue, { PropType } from "vue";
import { DialogI } from "@/types/dialog";
import BaseDialog from "@/components/dialog/BaseDialog.vue";
import Btn from "@/components/v2/base/Btn.vue";
import LessonWordsInfo from "@/components/words/lesson/LessonWordsInfo.vue";

export default Vue.extend({
  name: "LessonWordsInfoDialog",
  components: {
    BaseDialog,
    Btn,
    LessonWordsInfo,
  },
  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },
});
